module.exports = __webpack_public_path__ + "static/media/komponenty_charger.170f9bf1.svg";